import React from "react";
import {CommentProps} from "../../../../../components/comments/types";
import {StaticImage} from "gatsby-plugin-image";
import {Translate} from "../../../../../locales/locales-utils";

export const commentProps = (): CommentProps => {
    return {
        title: Translate("Index.Reviews.Title"),
        comments: [
            {
                body: Translate("Index.Reviews.Items.0.Comment"),
                name: Translate("Index.Reviews.Items.0.Name"),
                post: Translate("Index.Reviews.Items.0.Post"),
                img: (
                    <StaticImage
                        width={192}
                        height={192}
                        src={"../../../../../images/pages/ru-index/comments/avatars/anna.jpg"}
                        alt={"Анна Седловская"}
                    />
                ),
            },
            {
                body: Translate("Index.Reviews.Items.1.Comment"),
                name: Translate("Index.Reviews.Items.1.Name"),
                post: Translate("Index.Reviews.Items.1.Post"),
                img: (
                    <StaticImage
                        width={192}
                        height={192}
                        src={"../../../../../images/pages/ru-index/comments/avatars/alena.jpg"}
                        alt={"Алёна Манченко"}
                    />
                ),
            },
            {
                body: Translate("Index.Reviews.Items.2.Comment"),
                name: Translate("Index.Reviews.Items.2.Name"),
                post: Translate("Index.Reviews.Items.2.Post"),
                img: (
                    <StaticImage
                        width={192}
                        height={192}
                        src={"../../../../../images/pages/ru-index/comments/avatars/cingiz.jpg"}
                        alt={"Чингис Бальбаров"}
                    />
                ),
            },
            {
                body: Translate("Index.Reviews.Items.3.Comment"),
                name: Translate("Index.Reviews.Items.3.Name"),
                post: Translate("Index.Reviews.Items.3.Post"),
                img: (
                    <StaticImage
                        width={192}
                        height={192}
                        src={"../../../../../images/pages/ru-index/comments/avatars/andrey.jpg"}
                        alt={"Андрей Шершов"}
                    />
                ),
            },
            {
                body: Translate("Index.Reviews.Items.4.Comment"),
                name: Translate("Index.Reviews.Items.4.Name"),
                post: Translate("Index.Reviews.Items.4.Post"),
                img: (
                    <StaticImage
                        width={192}
                        height={192}
                        src={"../../../../../images/pages/ru-index/comments/avatars/pavel.jpg"}
                        alt={"Павел Деревянко"}
                    />
                ),
            },
            {
                body: Translate("Index.Reviews.Items.5.Comment"),
                name: Translate("Index.Reviews.Items.5.Name"),
                post: Translate("Index.Reviews.Items.5.Post"),
                img: (
                    <StaticImage
                        width={192}
                        height={192}
                        src={"../../../../../images/pages/ru-index/comments/avatars/yaroslav.jpg"}
                        alt={"Ярослав Морозов"}
                    />
                ),
            },
        ],
        classes: ["comments-container"]
    }
};
